import React from 'react';
import {
  DateField,
  RadioGroupField,
  Radio,
  SpacedFormLayout,
  TextField,
  LegendaryLabel,
} from '../../../components/styled/forms';
import {
  ExtenuatingFamilyCircumstance,
  MissedDeliveryReason,
} from './validation';
import { SecondaryBox } from '../../../components/styled/cards';
import { colors, space } from '../../../theme';
import { Box } from 'rebass';
import { AnnounceChange } from '../../../components/styled/forms/AnnounceChange';

export const SectionOption03NotDelivered: React.FC = () => {
  return (
    <SpacedFormLayout>
      <DateField
        name="scheduledAppointmentDate"
        label="Scheduled service date"
      />

      <RadioGroupField name="reasonForMissedDelivery">
        <LegendaryLabel variant="bigLabel">Why not?</LegendaryLabel>
        <Radio
          value={MissedDeliveryReason.ExtenuatingFamilyCircumstances}
          label="Exceptional family circumstances"
        >
          <SecondaryBox mt={space.one}>
            <RadioGroupField
              variant="radioPillGroup"
              name="extenuatingFamilyCircumstance"
            >
              <LegendaryLabel color={colors.deepTeal} mb={space.one}>
                What was the family circumstance?
              </LegendaryLabel>
              <Radio
                variant="radioPill"
                label="Loss of contact"
                value={ExtenuatingFamilyCircumstance.LossOfContact}
              />
              <Radio
                variant="radioPill"
                label="Family no-show"
                value={ExtenuatingFamilyCircumstance.FamilyNoShow}
              />
              <Radio
                variant="radioPill"
                label="Family cancelled"
                value={ExtenuatingFamilyCircumstance.FamilyCancelled}
              />
            </RadioGroupField>
          </SecondaryBox>
        </Radio>
        <Radio
          value={MissedDeliveryReason.ProviderSick}
          label="Provider sick"
        />
        <Radio
          value={MissedDeliveryReason.ProviderNotAvailable}
          label="Provider not available"
        />
        <Radio value={MissedDeliveryReason.AgencyDelay} label="Agency delay" />
        <Radio value={MissedDeliveryReason.Other} label="Other">
          <SpacedFormLayout>
            <Box ml={space.two}>
              <AnnounceChange>
                <TextField
                  autoFocus={true}
                  name={'reasonForMissedDeliveryNote'}
                  ariaLabel="Specify reason for missed delivery"
                />
              </AnnounceChange>
            </Box>
          </SpacedFormLayout>
        </Radio>
      </RadioGroupField>
    </SpacedFormLayout>
  );
};
